import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type {
  Error,
  License,
  LicenseQuery
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  params?: LicenseQuery
  onError?: (error: Error) => void
  onSuccess?: (data: License[]) => void
  children?: ((data: License[]) => ReactElement) | ((data: License[]) => void)
}

const GetAiLicensesRequest = ({
  params,
  onError,
  onSuccess,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/licenses`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default GetAiLicensesRequest
